import { _ } from "~/i18n";
import { node, icon } from "~/util/dom";

export function createGoToMapyCz() {
	const btn = node("button", { className: "control-go-to-mapycz", type: "button" }, _("inFrame.showOn"));

	btn.append(icon("logo"));
	btn.setAttribute("data-log-ignore", "1");
	btn.addEventListener("click", () => {
		Mapy.Util.openInNewWindow(true);
	});

	return btn;
}
